import { DemoHint, Slide, SlideBody, SlideText, type SlideProps } from '@components'
import { useOverlay } from '@stores'
import { useEffect } from 'react'

export function Shadows(props: SlideProps) {
  const setDemo = useOverlay(s => s.setDemo)

  useEffect(() => setDemo('8-shadows'), [setDemo])

  return (
    <Slide title="Shadows" {...props}>
      <SlideBody fontSize={0.28}>
        <SlideText bullet>Enable Renderer shadows</SlideText>
        <SlideText bullet>Specify which lights</SlideText>
        <SlideText anchorX={-0.18}>cast shadows</SlideText>
        <SlideText bullet>Specify which objects</SlideText>
        <SlideText anchorX={-0.18}>cast shadows</SlideText>
        <SlideText bullet>Specify which objects</SlideText>
        <SlideText anchorX={-0.18}>receive shadows</SlideText>
      </SlideBody>

      <DemoHint />
    </Slide>
  )
}
